import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { changeTime } from "../../../Hooks/changeTime";
import { Linkify } from "../LinkPreview/Linkify";
// import { LinkPreview } from "@dhaiwat10/react-link-preview";

export default function MessageContainer({ position, message, time }) {
  const [nepalTime, setNepalTime] = useState();
  // const [isLink, setIsLink] = useState(false);

  // const [data, setData] = useState(null);

  useEffect(() => {
    const nepTime = changeTime(time);
    setNepalTime(nepTime);
  }, [time]);

  const currRole = useSelector((state) => state.chatRole.role);

  const newPosition = useMemo(() => {
    if (currRole === "seller") {
      if (position === "right") {
        return "left";
      } else {
        return "right";
      }
    }
    return position;
  }, [currRole, position]);

  // const fetchLink = async (link) => {
  //   const res = await fetch(link, {
  //     headers: {
  //       'content-type': 'text/plain'
  //     }
  //   })

  //   console.log('Response ', res)
  // }

  // useEffect(() => {

  //   const isUrl = (word) => {
  //     const urlPattern =
  //       /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
  //     return word.match(urlPattern);
  //   };
  //   const link = message.split(" ").filter(item => isUrl(item))[0]

  //   if (link) {
  //     fetchLink(link)

  //   }


  // }, [])


  // useEffect(() => {
  //   const isUrl = (word) => {
  //     const urlPattern =
  //       /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
  //     return word.match(urlPattern);
  //   };
  //   if (isUrl(message)) {
  //     setIsLink(true);
  //     console.log(isUrl(message));
  //     // Fetch data from the URL (you can use a proxy server if needed)
  //     fetch(`https://api.scraperapi.com?api_key=1c5af0f8dc3721c33b034e1d13cf99f8&autoparse=true&url=${message}`

  //     )
  //       .then((response) => response.json())
  //       .then((responseData) => {
  //         setData(responseData);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching link preview data:", error);
  //       });
  //   }
  // }, [message]);

  // if (!data) {
  //   return null; // Render nothing until data is available
  // }

  // const { title, description, image } = data;

  return (
    <div
      className={`single-message-container ${newPosition === "right" ? "incoming-message" : "outgoing-message"
        }`}
    >
      <div
        style={{
          display: "flex",
          className: "message-content",
          alignItems: newPosition === "right" ? "flex-start" : "flex-end",
          flexDirection: "column",
          marginBottom: 5
        }}
      >
        {/* {isLink && (
          <div className="link-preview">
            {image && <img src={image} alt="Link Preview" />}
            <div className="preview-details">
              {title && <h3>{title}</h3>}
              {description && <p>{description}</p>}
            </div>
          </div>
        )} */}
        <h6 className="mb-0">
          <Linkify>{message}</Linkify>
        </h6>

        <span
          style={{
            fontSize: "10px",
            color: "#9e9e9e",
            textAlign: "right",
          }}
        >
          {time && nepalTime}
        </span>
      </div>
    </div>
  );
}
